// extracted by mini-css-extract-plugin
module.exports = {"root":"_eb922a"};